import { get } from "../../../shared/data";

export const getShipment = (shipmentKey) => {
    return get(`/receiving/shipments/${shipmentKey}`);
};

export const getLookups = () => {
    return get("/receiving/lookups");
};

export const getLabels = (shipmentKey) => {
    return get(`/receiving/shipments/${shipmentKey}/products`).then((products) => {
        return products.reduce((binList, product) => {
            if (!binList.includes(product.binTrackingNumber)) {
                binList.push(product.binTrackingNumber);
            }

            return binList;
        }, []);
    });
};

export const getProducts = (shipmentKey) => {
    const url = `/tasking/contexts?shipment=${shipmentKey}`;

    return get(url);
};

export const getDueDates = (key, isDuplicateStageProduct) => {
    const isDuplicate = isDuplicateStageProduct ? "?showDuplicateStagedProducts=true" : "";

    return get(`/tasking/tasks/list/${key}${isDuplicate}`).then((products) => {
        return products.reduce((dates, t) => {
            if (t.taskType === "measuring.standard" || t.taskType === "photography.standard") {
                dates.push({
                    tags: t.tags,
                    due: t.due,
                });
            }

            return dates;
        }, []);
    });
};
